module.exports = __webpack_public_path__ + "img/image2.766543d9.jpg";